import { render, staticRenderFns } from "./liquorUser.vue?vue&type=template&id=0fb5b914&scoped=true"
import script from "./liquorUser.vue?vue&type=script&lang=js"
export * from "./liquorUser.vue?vue&type=script&lang=js"
import style0 from "./liquorUser.vue?vue&type=style&index=0&id=0fb5b914&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb5b914",
  null
  
)

export default component.exports